export default "__VITE_ASSET__CSf_H37x__"